const LOCAL_TEST_WALLET_SHORTCUT_HOSTNAMES = new Set([
  'localhost',
  '127.0.0.1',
  '0.0.0.0',
  '::1',
  '[::1]',
]);

export function getIsLocalTestWalletShortcutHostname(hostname: string) {
  return LOCAL_TEST_WALLET_SHORTCUT_HOSTNAMES.has(hostname);
}

export function getIsLocalTestWalletShortcutEnabled(
  hostname = typeof window === 'undefined' ? undefined : window.location.hostname,
) {
  return !!hostname && getIsLocalTestWalletShortcutHostname(hostname);
}
